import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { zipCodeRegex } from "Features/CheckPrice/Products/RiskProducts/riskProductsUtils";
import { CabinContentsProductIntroFormValues } from "../cabinContentsInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<CabinContentsProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object({
      postNumber: Yup.string()
        .required(getText("cabincontentsform.validation.postnumber_required"))
        .matches(
          zipCodeRegex,
          getText("cabincontentsform.validation.postnumber_invalid"),
        )
        .test(
          "postNumberValid",
          getText("cabincontentsform.validation.postnumber_invalid"),
          function () {
            return this.parent.validPostNumber;
          },
        ),
      validPostNumber: Yup.boolean(),
      city: Yup.string(),
    }).defined();
  };
